import { ApiError, apiGet, apiPost } from "@/api/api.ts"

export class UnauthenticatedError extends Error {
}

export class InvalidUserConfigError extends Error {
}

export async function login(username: string, password: string): Promise<string> {
	const response = await apiPost("login", { username, password })

	if (!response.ok) {
		if (response.status === 401) {
			throw new UnauthenticatedError("Zugangsdaten falsch")
		}

		const body = await response.json()

		throw new ApiError(body.message ?? "Unbekannter Fehler")
	}

	const body = await response.json()

	if (!body.token || typeof body.token !== "string") {
		throw new InvalidUserConfigError("Die API hat keinen gültigen Token zurückgegeben.")
	}
	try {
		return body.token
	} catch (err) {
		throw new ApiError("Could not get user from token")
	}
}

export async function logout(token: string): Promise<boolean> {
	const response = await apiGet("logout", token)

	if (!response.ok) {
		throw new ApiError("Could not log out user")
	}

	return true
}

export default {
	login,
	logout,
}
